const selectQuerySettings = (state) => state.querySettings;
export default selectQuerySettings;
